import { EditorJsOutputData } from "@dashboard/utils/richText/types";

import { defaultArticlesContent } from "./defaultArticlesContent";
import { defaultCompanyContent } from "./defaultCompanyContent";
import { defaultCustomerServiceContent } from "./defaultCustomerServiceContent";
import { defaultInquiryFormsContent } from "./defaultInquiryFormsContent";
import { defaultLegalContent } from "./defaultLegalContent";
import { defaultPagesContent } from "./defaultPagesContent";
import { defaultPromotionContent } from "./defaultPromotionContent";
import { defaultStorefrontSectionsContent } from "./defaultStorefrontSectionsContent";
import { defaultTestimonialContent } from "./defaultTestimonialContent";
import { defaultTypeContent } from "./defaultTypeContent";
import type { PageTypeContentModule } from "./types";

export type { PageTypeContentModule } from "./types";

const contentRegistry: Readonly<Record<string, PageTypeContentModule>> = {
  "articles-blogs": defaultArticlesContent,
  "company": defaultCompanyContent,
  "customer-service": defaultCustomerServiceContent,
  "default-type": defaultTypeContent,
  "inquiry-forms": defaultInquiryFormsContent,
  "legal": defaultLegalContent,
  "pages": defaultPagesContent,
  "promotion": defaultPromotionContent,
  "storefront-sections": defaultStorefrontSectionsContent,
  "testimonial": defaultTestimonialContent,
} as const;

export function getDefaultContentForPageType(
  pageTypeSlug: string | undefined | null
): EditorJsOutputData | undefined {
  if (!pageTypeSlug) return undefined;

  return contentRegistry[pageTypeSlug]?.content;
}

export function getContentMetaForPageType(
  pageTypeSlug: string | undefined | null
): PageTypeContentModule | undefined {
  if (!pageTypeSlug) return undefined;

  return contentRegistry[pageTypeSlug];
}

export function hasDefaultContentForPageType(
  pageTypeSlug: string | undefined | null
): boolean {
  if (!pageTypeSlug) return false;

  return pageTypeSlug in contentRegistry;
}

export function getRegisteredPageTypeSlugs(): string[] {
  return Object.keys(contentRegistry);
}
